/* eslint-disable */
<template>
  <div>
    <div v-if="services" v-for="(service, serviceKey) of services" :key="serviceKey" class="m-2">
      <h1 class="mt-6">{{ service.label }}</h1>
      <div v-if="admin" class="w-full pin-b pin-l">
        <button class="text-xs p-1" v-on:click.stop="deleteService(serviceKey)">&#215;</button>
      </div>
      <form v-if="admin" v-on:submit.prevent="addDay" class="rounded pt-2 mx-3 m-4 p-3 bg-grey-lighter">
        <div class="flex border-b border-b-2 border-blue py-2">
          <input type="hidden" name="service" :value="serviceKey" />
          <input class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2" name="date" type="date" placeholder="Datum">
          <input class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2" name="label" type="text" placeholder="Beschreibung/Tag">
          <button class="flex-no-shrink bg-blue hover:bg-blue-dark border-blue hover:border-blue-dark text-sm border-4 text-white py-1 px-2 rounded" type="submit">+</button>
        </div>
      </form>
      <div class="px-0">
        <div class="block flex flex-wrap">
          <div class="flex-1" v-for="(day, dayKey) of days[serviceKey]" :key="dayKey">
            <h2>{{ day.date | moment("dddd") }}</h2>
            <h3>{{ day.date | moment("Do MMM") }}</h3>
            <div v-if="admin" class="pin-b pin-l">
              <button class="text-xs p-1" v-on:click.stop="deleteDay(serviceKey, dayKey)">&#215;</button>
              <button class="text-xs p-1" v-on:click.stop="openDay(serviceKey, dayKey)">&#x270e;</button>
            </div>
            <div v-for="(job, jobKey) of jobs[dayKey]" :key="jobKey" @click="open(serviceKey, dayKey, jobKey)" :class="size('participants', jobKey) < job.required ? 'bg-yellow hover:bg-yellow-lighter' : 'bg-green-light'" class="cursor-pointer relative text-center text-black justify-between leading-normal m-3 p-4 rounded-lg">
              <div class="w-full mb-3 absolute pin-t pin-l">
                <div class="w-full">
                  <div class="float-right text-xs p-1">{{ job.required - size('participants', jobKey)}}</div>
                  <div v-if="size('participants', jobKey) < job.required" class="bg-green-light h-2 rounded-tl-lg" :style="'width: ' + size('participants', jobKey) * 100 / job.required + '%'"></div>
                </div>
              </div>
              <div class="font-bold text-xl"> {{ job.label }} </div>
              <div>
                <div class="text-xs px-1" v-for="(participant, participantKey) of participants[jobKey]" :key="participantKey">
                  <button v-if="admin" class="text-xs" v-on:click.stop="deleteParticipant(jobKey, participantKey)">&#215;</button> {{ users[participant.user.id].name || participant.user.email }} <span v-if="participant.accepted">&#10003;</span></div>
              </div>
              <div v-if="admin" class="absolute pin-b pin-l">
                <button class="float-left text-xs p-1" v-on:click.stop="deleteJob(dayKey, jobKey)">&#215;</button>
              </div>
              <div v-if="admin" class="absolute pin-b pin-r">
                <button class="float-right text-xs p-1" v-on:click.stop="openJob(dayKey, jobKey)">&#x270e;</button>
              </div>
            </div>
            <form v-if="admin" v-on:submit.prevent="addJob" class="rounded pt-2 mx-3 m-4 p-3 bg-grey-lighter">
              <div class="flex flex-col border-b border-b-2 border-blue py-2">
                <input type="hidden" name="day" :value="dayKey" />
                <input class="appearance-none bg-transparent border-none w-full text-grey-darker mb-3 py-1 px-2" name="label" type="text" placeholder="Uhrzeit">
                <input class="appearance-none bg-transparent border-none w-full text-grey-darker mb-3 py-1 px-2" name="required" id="required" type="number" placeholder="1">
                <button class="flex-no-shrink bg-blue hover:bg-blue-dark border-blue hover:border-blue-dark text-sm border-4 text-white py-1 px-2 rounded" type="submit">+</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <form v-if="admin" v-on:submit.prevent="addService" class="rounded pt-2 mx-3 mt-8 p-3 bg-grey-lighter">
      <div class="flex border-b border-b-2 border-blue py-2">
        <input class="appearance-none bg-transparent border-none w-full text-grey-darker mr-3 py-1 px-2" name="label" type="text" placeholder="Dienst">
        <button class="flex-no-shrink bg-blue hover:bg-blue-dark border-blue hover:border-blue-dark text-sm border-4 text-white py-1 px-2 rounded" type="submit">+</button>
      </div>
    </form>
    <div v-if="modal" class="bg-grey-lighter animated fadeIn fixed z-10 pin overflow-auto bg-smoke-dark flex">
      <div class="animated fadeInUp fixed shadow-inner max-w-md md:relative pin-b pin-x align-top m-auto justify-end md:justify-center p-3 bg-white md:rounded w-full md:h-auto md:shadow flex flex-col">
        <h2 class="text-4xl text-center font-hairline md:leading-loose text-grey md:mt-2 mb-2">Eintragen</h2>
        <p class="text-xl leading-normal mb-4 text-center">
          Für den Dienst <span class="font-bold">{{ participant.service.label || '' }}</span> am <span class="font-bold">{{ participant.day.label || '' }}</span>, den <span class="font-bold">{{ participant.day.date || '' }}</span> um <span class="font-bold">{{ participant.job.label || '' }}</span>        Uhr
        </p>
        <div class="inline-flex justify-center">
          <button @click="apply" class="bg-grey-lighter flex-1 border-b-2 md:flex-none border-green ml-2 hover:bg-green-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                                                        Ja
                                 </button>
          <button @click="close" class="bg-grey-lighter flex-1 md:flex-none border-b-2 border-red ml-2 hover:bg-red-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                        Nein                            
                        </button>
        </div>
        <span @click="close" class="absolute pin-t pin-r pt-4 px-4">
                                                    <svg class="h-12 w-12 text-grey hover:text-grey-darkest" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                                                </span>
      </div>
    </div>
    <div v-if="modalJob" class="bg-grey-lighter animated fadeIn fixed z-10 pin overflow-auto bg-smoke-dark flex">
      <div class="animated fadeInUp fixed shadow-inner max-w-md relative pin-b pin-x align-top m-auto justify-end md:justify-center p-4 bg-white md:rounded w-full md:h-auto md:shadow flex flex-col">
        <h2 class="text-4xl text-center font-hairline md:leading-loose text-grey mt-1 mb-3">Dienstzeit bearbeiten</h2>
        <div class="flex flex-wrap mb-6">
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="job-label">
              Uhrzeit
            </label>
            <input v-model="job.label" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="job-label" type="text">
          </div>
          <div class="w-full md:w-1/2 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="job-required">
              Personenanzahl
            </label>
            <input v-model="job.required" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="job-required" type="number">
          </div>
        </div>
        <div class="inline-flex justify-center">
          <button @click="editJob" class="bg-grey-lighter flex-1 border-b-2 md:flex-none border-green ml-2 hover:bg-green-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                  Speichern
              </button>
          <button @click="close" class="bg-grey-lighter flex-1 md:flex-none border-b-2 border-red ml-2 hover:bg-red-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                  Abbrechen                            
              </button>
        </div>
        <span @click="close" class="absolute pin-t pin-r pt-4 px-4">
               <svg class="h-12 w-12 text-grey hover:text-grey-darkest" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
             </span>
      </div>
    </div>
    <div v-if="modalDay" class="bg-grey-lighter animated fadeIn fixed z-10 pin overflow-auto bg-smoke-dark flex">
      <div class="animated fadeInUp fixed shadow-inner max-w-md relative pin-b pin-x align-top m-auto justify-end md:justify-center p-4 bg-white md:rounded w-full md:h-auto md:shadow flex flex-col">
        <h2 class="text-4xl text-center font-hairline md:leading-loose text-grey mt-1 mb-3">Tag bearbeiten</h2>
        <div class="flex flex-wrap mb-6">
          <div class="w-full md:w-1/2 px-3">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="day-date">
              Datum
            </label>
            <input v-model="day.date" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="day-date" type="date">
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2" for="day-label">
              Beschreibung
            </label>
            <input v-model="day.label" class="appearance-none block w-full bg-grey-lighter text-grey-darker border border-grey-lighter rounded py-3 px-4" id="day-label" type="text">
          </div>
        </div>
        <div class="inline-flex justify-center">
          <button @click="editDay" class="bg-grey-lighter flex-1 border-b-2 md:flex-none border-green ml-2 hover:bg-green-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                  Speichern
              </button>
          <button @click="close" class="bg-grey-lighter flex-1 md:flex-none border-b-2 border-red ml-2 hover:bg-red-lightest text-grey-darkest font-bold py-4 px-6 rounded">
                  Abbrechen                            
              </button>
        </div>
        <span @click="close" class="absolute pin-t pin-r pt-4 px-4">
               <svg class="h-12 w-12 text-grey hover:text-grey-darkest" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
             </span>
      </div>
    </div>
  </div>
</template>

<script>
  import fire from '../firebase'
  import timeslot from '@/components/Slot'

  export default {
    components: {
      timeslot
    },
    data () {
      return {
        admin: this.$root.$data.admin,
        modal: false,
        modalJob: false,
        modalDay: false,
        services: {},
        days: {},
        jobs: {},
        users: {},
        participants: {},
        participant: {
          serviceKey: '',
          service: '',
          dayKey: '',
          day: '',
          jobKey: '',
          job: ''
        },
        job: {
          dayKey: '',
          jobKey: '',
          label: '',
          required: ''
        },
        day: {
          serviceKey: '',
          dayKey: '',
          label: '',
          date: ''
        }
      }
    },
    created () {
      this.refToObject('users')
      this.refToObject('services')
      this.refToObject('days', 'date')
      this.refToObject('jobs', 'label')
      this.refToObject('participants')
    },
    methods: {
      refToObject: function (name, orderBy) {
        let vm = this
        orderBy = orderBy || 'id'
        fire.db.ref(name).orderByChild(orderBy).on('child_added', function (item) {
          let obj = {}
          obj[item.key] = item.val()
          vm[name] = Object.assign({}, vm[name], obj)
          // console.log('child_added debug: ' + name, vm[name])
        })
        fire.db.ref(name).orderByChild(orderBy).on('child_changed', function (item) {
          let obj = {}
          obj[item.key] = item.val()
          vm[name] = Object.assign({}, vm[name], obj)
          // console.log('child_changed debug: ' + name, vm[name])
        })
        // console.log('debug: ' + name, this[name])
      },
      addService: function () {
        const payload = {
          label: event.target.elements.label.value
          // description: event.target.elements.description.value
        }
        console.log('service', payload)
        fire.db.ref('services').push(payload)
        event.target.elements.label.value = ''
      },
      deleteService: function (serviceKey) {
        if (confirm('Wirklich löschen?')) {
          const servicePath = 'services/' + serviceKey
          const dayPath = 'jobs/' + serviceKey
          fire.db.ref(servicePath).remove()
          fire.db.ref(dayPath).remove()
          console.log('deleting', servicePath)
          console.log('deleting', dayPath)
        }
      },
      addDay: (event) => {
        const key = fire.db.ref('days').push().key
        const service = event.target.elements.service.value
        const path = 'days/' + service + '/' + key
        const payload = {
          date: event.target.elements.date.value,
          label: event.target.elements.label.value
        }
        console.log(path, payload)
        fire.db.ref(path).update(payload)
        event.target.elements.date.value = ''
        event.target.elements.label.value = ''
      },
      openDay: function (serviceKey, dayKey) {
        this.modalDay = true
        this.day.serviceKey = serviceKey || ''
        this.day.dayKey = dayKey || ''
        this.day.label = this.days[serviceKey][dayKey]['label'] || ''
        this.day.date = this.days[serviceKey][dayKey]['date'] || ''
      },
      editDay: function () {
        console.log('update-day', this.day)
        const path = 'days/' + this.day.serviceKey + '/' + this.day.dayKey
        const payload = {
          label: this.day.label,
          date: this.day.date
        }
        console.log(path, payload)
        fire.db.ref(path).update(payload)
        this.close()
      },
      deleteDay: function (serviceKey, dayKey) {
        if (confirm('Wirklich löschen?')) {
          const dayPath = 'days/' + serviceKey + '/' + dayKey
          const jobPath = 'jobs/' + dayKey
          fire.db.ref(dayPath).remove()
          fire.db.ref(jobPath).remove()
          console.log('deleting', dayPath)
          console.log('deleting', jobPath)
        }
      },
      addJob: (event) => {
        const key = fire.db.ref('jobs').push().key
        const day = event.target.elements.day.value
        const path = 'jobs/' + day + '/' + key
        const payload = {
          label: event.target.elements.label.value,
          required: event.target.elements.required.value,
          participants: []
        }
        console.log(path, payload)
        fire.db.ref(path).update(payload)
        event.target.elements.label.value = ''
        event.target.elements.required.value = 1
      },
      openJob: function (dayKey, jobKey) {
        this.modalJob = true
        this.job.dayKey = dayKey || ''
        this.job.jobKey = jobKey || ''
        this.job.label = this.jobs[dayKey][jobKey]['label'] || ''
        this.job.required = this.jobs[dayKey][jobKey]['required'] || ''
      },
      editJob: function () {
        console.log('update-job', this.job)
        const path = 'jobs/' + this.job.dayKey + '/' + this.job.jobKey
        const payload = {
          label: this.job.label,
          required: this.job.required
        }
        console.log(path, payload)
        fire.db.ref(path).update(payload)
        this.close()
      },
      deleteJob: function (dayKey, jobKey) {
        if (confirm('Wirklich löschen?')) {
          const jobPath = 'jobs/' + dayKey + '/' + jobKey
          const participantPath = 'participants/' + jobKey
          fire.db.ref(jobPath).remove()
          fire.db.ref(participantPath).remove()
          console.log('deleting', jobPath)
          console.log('deleting', participantPath)
        }
      },
      size: function (name, key) {
        let size = 0
        if (this[name].hasOwnProperty(key)) { // eslint-disable-next-line
          for (let item in this[name][key]) {
            size++
          }
        }
        return size
      },
      open: function (serviceKey, dayKey, jobKey) {
        this.modal = true
        this.participant.serviceKey = serviceKey || ''
        this.participant.service = this.services[serviceKey] || ''
        this.participant.dayKey = dayKey || ''
        this.participant.day = this.days[serviceKey][dayKey] || ''
        this.participant.jobKey = jobKey || ''
        this.participant.job = this.jobs[dayKey][jobKey] || ''
        console.log('participant', this.participant)
      },
      close: function () {
        this.modal = false
        this.modalJob = false
        this.modalDay = false
      },
      apply: function (event) {
        console.log('apply-participant', this.participant)
        const key = fire.db.ref('participants').push().key
        const path = 'participants/' + this.participant.jobKey + '/' + key
        const payload = {
          serviceKey: this.participant.serviceKey,
          dayKey: this.participant.dayKey,
          jobKey: this.participant.jobKey,
          user: {
            id: fire.app.auth().currentUser.uid,
            email: fire.app.auth().currentUser.email
          },
          accepted: false,
          declined: false,
          date: new Date()
        }
        console.log(path, payload)
        fire.db.ref(path).update(payload)
        this.close()
      },
      deleteParticipant: function (jobKey, participantKey) {
        if (confirm('Wirklich löschen?')) {
          const participantPath = 'participants/' + jobKey + '/' + participantKey
          fire.db.ref(participantPath).remove()
          console.log('deleting', participantPath)
        }
      },
      updateItem: function (item) {
        // create a copy of the item
        item = { ...item
        }
        // remove the .key attribute
        delete item['.key']
        this.$firebaseRefs.services.child(item['.key']).set(item)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Services.vue